import { apiClient } from './apiClient';

 
export const getInsuranceService = async (proxyBaseUrl: string, apiKey: string, arn: string | undefined): Promise<any> => {
    return apiClient<unknown>(`${proxyBaseUrl}/insurance/price/${arn}`, {
        method: 'GET',
        apiKey,
        sentryTag: 'get_insurance',
        sentryExtra: { arn },
    });
};
